import { TextField } from '@mui/material'
import { useDispatch } from 'react-redux'
import { useSelector } from 'src/utils/store'
import { actions } from '../../ReceivementOverviewListState'

export const InvoiceKeyFilterInput = () => {
  const dispatch = useDispatch()
  const invoiceKey = useSelector((state) => state.receivementOverviewList.invoiceKey)

  const setInvoiceKey = (event: React.ChangeEvent<{ value: string }>) => {
    const { value } = event.target
    dispatch(actions.updateOverviewFilterField({ key: 'invoiceKey', value }))
  }

  return (
    <TextField
      autoComplete='off'
      label='Chave da Nota'
      variant='outlined'
      size='small'
      value={invoiceKey}
      onChange={setInvoiceKey}
      inputProps={{ 'data-testid': 'invoice-key-input' }}
    />
  )
}
